var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H120V120H0V0Z",
    fill: "#F6F8FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1373 70.1098V49.0275C77.1373 47.1637 76.3969 45.3762 75.079 44.0583C73.7611 42.7404 71.9736 42 70.1098 42H49.0275C47.1637 42 45.3762 42.7404 44.0583 44.0583C42.7404 45.3762 42 47.1637 42 49.0275V70.1098C42 71.9736 42.7404 73.7611 44.0583 75.079C45.3762 76.3969 47.1637 77.1373 49.0275 77.1373M77.1373 70.1098C77.1373 71.9736 76.3969 73.7611 75.079 75.079C73.7611 76.3969 71.9736 77.1373 70.1098 77.1373H49.0275M77.1373 70.1098L77.1373 70.3435C77.1373 72.1453 76.4215 73.8733 75.1474 75.1474C73.8733 76.4215 72.1453 77.1373 70.3435 77.1373L49.0275 77.1373M77.1373 70.1098C77.1373 69.2911 76.8298 68.9766 76.2764 68.3705L69.1962 60.6491C68.8663 60.2891 68.4649 60.0019 68.0177 59.8058C67.5705 59.6096 67.0873 59.5088 66.599 59.5098C66.1107 59.5108 65.628 59.6135 65.1816 59.8115C64.7352 60.0095 64.335 60.2984 64.0065 60.6596L49.0275 77.1373M57.8118 53.4196C57.8118 55.8453 55.8453 57.8118 53.4196 57.8118C50.9939 57.8118 49.0275 55.8453 49.0275 53.4196C49.0275 50.9939 50.9939 49.0275 53.4196 49.0275C55.8453 49.0275 57.8118 50.9939 57.8118 53.4196Z",
    stroke: "#C4C4C4",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImage);
export default __webpack_public_path__ + "static/media/emptyImage.svg";
export { ForwardRef as ReactComponent };